// Implementazione firma cieca
const secureRandom = require("secure-random");

import forge from "node-forge";
const BigInteger = forge.jsbn.BigInteger;
import TextEncoding from "text-encoding/lib/encoding";

function parseBigInteger(b64) {
  return new BigInteger(forge.util.bytesToHex(forge.util.decode64(b64)), 16);
}
function parseB64(bigInteger) {
  return forge.util.encode64(forge.util.hexToBytes(bigInteger.toString(16)));
}

function messageToHashInt(message) {
  var uint8array = new TextEncoding.TextEncoder("utf-8").encode(message);
  let hex = forge.util.bytesToHex(uint8array);
  const messageBig = new BigInteger(hex, 16);
  return messageBig;
}

function generateBlindFactor(N, E) {
  const bigOne = new BigInteger("1");
  let gcd;
  let r;
  do {
    r = new BigInteger(secureRandom(80));
    gcd = r.gcd(N);
  } while (
    !gcd.equals(bigOne) ||
    r.compareTo(N) >= 0 ||
    r.compareTo(bigOne) <= 0
  );
  return r;
}
function blind({ message, N, E, blindFactor, inputType }) {
  N = new BigInteger(N.toString());
  E = new BigInteger(E.toString());
  let messageHash = null;
  if (!inputType || inputType === "string")
    messageHash = messageToHashInt(message);
  if (inputType === "hex") messageHash = new BigInteger(message, 16);
  if (messageHash.compareTo(N) >= 0) {
    throw "Message is larger than modulus";
  }
  let r = null;
  if (blindFactor === "test") {
    r = new BigInteger("1926836790404252624");
  } else r = generateBlindFactor(N, E);

  const blinded = messageHash.multiply(r.modPow(E, N)).mod(N);
  let out = parseB64(blinded);
  return { blinded: out, r: r.toString() };
}
function unblind({ signed, r, N }) {
  r = new BigInteger(r.toString());
  N = new BigInteger(N.toString());
  let signedIn = parseBigInteger(signed);
  const unblinded = signedIn.multiply(r.modInverse(N)).mod(N);
  let out = parseB64(unblinded);
  return out;
}

function verify({ unblinded, message, E, N, inputType }) {
  let unblindedIn = parseBigInteger(unblinded);
  let messageHash = null;
  if (inputType === "string" || !inputType)
    messageHash = messageToHashInt(message);
  if (inputType === "hex") messageHash = new BigInteger(message, 16);
  N = new BigInteger(N.toString());
  E = new BigInteger(E.toString());
  const originalMsg = unblindedIn.modPow(E, N);
  const result = messageHash.equals(originalMsg);
  return result;
}

function sign({ blinded, N, D }) {
  N = new BigInteger(N.toString());
  D = new BigInteger(D.toString());

  let blindedIn = parseBigInteger(blinded);
  const signed = blindedIn.modPow(D, N);
  let out = parseB64(signed);
  return out;
}
export { blind, unblind, verify, sign };
